export const parseImagePath = (imagePath) => {
  const brokenPath = imagePath.split('/');
  console.log(brokenPath);
  return brokenPath[brokenPath.length - 1];
};
